// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiType: 'API',
  apiUrl: '',
  sensorImage: true,
  autoRefreshSec: 15,
  firebase: {
    // apiKey: "AIzaSyCdccUdM61wWbd0ZOBZt9DIrDRUR81DqxI",
    // authDomain: "whizzstar-sg.firebaseapp.com",
    // databaseURL: "https://whizzstar-sg.firebaseio.com",
    // projectId: "whizzstar-sg",
    // storageBucket: "whizzstar-sg.appspot.com",
    // messagingSenderId: "658646314014",
//     apiKey: "config data from general tab",
//  authDomain: "config data from general tab",
//  projectId: "config data from general tab",
//  storageBucket: "config data from general tab",
//  messagingSenderId: "config data from general tab",
//  appId: "config data from general tab",
//  measurementId: "config data from general tab"
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
    apiKey: "AIzaSyDqaiZyNClIRMIVjCxzc_NRr-kVIwR4UTg",
    authDomain: "contando-6acdd.firebaseapp.com",
    projectId: "contando-6acdd",
    storageBucket: "contando-6acdd.appspot.com",
    messagingSenderId: "505546698846",
    appId: "1:505546698846:web:4915eabb052380155e84cf",
    measurementId: "G-1DMWWH6PYD",
    vapidKey: "BGYdMQfc5IjnMDulkgIvnVHKIhakqFzvUIJcyhTnZQRDJK1OlUJ61LdVVmBG9XPjpKVesG_4fjkZdMWCRkikcko"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
